import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { SharedService } from "./../../../shared/shared.service";
import { AdminDevoteeService } from './../../services/admin-devotee.service';
import { DevoteeDetail } from "./../../../devotee/devotee-detail";
import { PagingGridData } from "./../../models/paging-grid-data";

@Component({
  selector: 'app-devotee-address-print',
  templateUrl: './devotee-address-print.component.html',
  styleUrls: ['./devotee-address-print.component.css'],
  providers: [AdminDevoteeService]
})
export class DevoteeAddressPrintComponent implements OnInit {

  constructor(private formBuilder: FormBuilder,
    private sharedService: SharedService,
    private adminDevoteeService: AdminDevoteeService) { }

  devoteeList: DevoteeDetail[] = [];
  totalPage: number;
  errorMessage: string = "";
  searchForm: FormGroup;

  ngOnInit() {
    this.createSearchForm();
  }

  devoteeSearch() {

    let searchGridEntity = this.searchForm.value;

    this.sharedService.showSpinner();
    this.adminDevoteeService.searchDevoteeForPrint(searchGridEntity).subscribe(
      data => {
        console.log(data);
        this.devoteeList = data;
      },
      err => this.errorMessage = err,
      () => this.sharedService.hideSpinner()
    )

  }


  createSearchForm(): void {
    this.searchForm = this.formBuilder.group({
      PDN: [],
      FirstName: [""],
      MiddleName: [""],
      LastName: [""],
      AddressLine1: [],
      AddressLine2: [],
      AddressLine3: [],
      AddressLine4: [],
      City: [],
      State: [],
      PinCode: [],
      MobileNo: [],
      Email: []
    });
  }


  print(): void {
    let printContents, popupWin;
    printContents = document.getElementById('print-section').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=700,width=1000');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <!-- Latest compiled and minified CSS -->
<link rel="stylesheet" href="bootstrap.css">

<!-- Optional theme -->


          <style>
          //........Customized style.......
          
          body {
            font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
            font-size: 14px;
            line-height: 1.42857143;
            color: #333;
            background-color: #fff;
        }

.innerbox{
    padding-top: 5px;
    padding-left: 10px;    
}

.barcode { font-family: "Free 3 of 9";font-size: 32px }

.boxlabel{
        /* Avery 5160 labels -- CSS and HTML by MM at Boulder Information Services */
        width: 2.51in; /* plus .6 inches from padding */
        height: 2.17in; /*.875in; /* plus .125 inches from padding */
        padding: 2px .1in 0;
        margin-right: .125in; /* the gutter */
        margin-bottom: 10px;
        font-size: 13px;
        float: left;
        /*text-align: center;*/
        overflow: hidden;
        outline: 1px dotted; /*outline doesn't occupy space like border does border-bottom: 1px dotted */
        color: black;
      }
      
      .pagebody {
        width: 8.5in;            
        margin-left: 10px;
        }
      
    .page-break  {
        clear: left;
        display:block;
        page-break-after:always;
    }

    .boxlabel:nth-child(15n+1){
            margin-top: 20px;
        }
        .boxlabel:nth-child(15n+2) {
            margin-top: 20px;
        }
        .boxlabel:nth-child(15n+3){
            margin-top: 20px;
        }
          </style>

          <!-- Latest compiled and minified JavaScript -->
<script src="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/js/bootstrap.min.js" integrity="sha384-Tc5IQib027qvyjSMfHjOMaLkfuWVxZxUPnCJA7l2mCWNIpG9mGCD8wGNIcPD7Txa" crossorigin="anonymous"></script>
            
       
        </head>
    <body >${printContents}</body>
      </html>`
    );
    popupWin.document.close();
  }

}

// onload="window.print();window.close()"



// WEBPACK FOOTER //
// ./src/app/admin/components/devotee-address-print/devotee-address-print.component.ts